import { VueApp } from '@/setup/CreateApp'
import router from '@/router'

VueApp.use(router)
